import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Chip as MuiChip } from '@mui/material';
import { alpha } from '@mui/material/styles';

const Chip = styled(({ className, $color, ...props }) => (
  <MuiChip
    {...props}
    className={className}
    classes={{ icon: 'icon', label: 'label' }}
  />
))`
  && {
    background-color: ${(props) =>
      props.$backgroundColor
        ? props.$backgroundColor
        : alpha(props.theme.palette.colors.black, 0.03)};
    color: ${({ $color, theme }) => $color || theme.palette.colors.black};
    border: ${(props) =>
      props.variant === 'outlined' ? '1px solid #eee' : 'none'};
    border-radius: 20px;
    font-weight: 600;
    height: ${(props) => (props.size === 'small' ? 'initial' : '32px')};
    padding: 4px;
    min-width: 32px;

    :hover {
      background-color: ${({ $color, theme }) => $color || alpha(theme.palette.colors.black, 0.03)};
      color: ${(props) =>
        props.$backgroundColor ? props.$backgroundColor : props.theme.palette.colors.black};
      & .icon {
        color: ${(props) =>
          props.$backgroundColor ? props.$backgroundColor : props.theme.palette.colors.black};
      }
    }

    & .icon {
      color: ${({ $color, theme }) => $color || theme.palette.colors.black};
      margin-left: ${(props) => (props.label ? '5px' : 0)};
      font-size: ${(props) => (props.fontSize ? props.fontSize : '15px')};
    }

    & .label {
      padding-right: ${(props) => (props.label ? '12px' : 0)};
      padding-left: ${(props) => (props.label ? '12px' : '5px')};
    }
  }
`;

Chip.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'warning',
    'info',
    'default',
  ]),
};
Chip.defaultProps = {
  color: 'default',
};

export default Chip;
